// Needs a GTM tag before it reaches GA4 — untagged dataLayer pushes drop
// silently. Fires at most once per mount (not once per page view — a
// re-mount, e.g. after a client-side nav back to the buy page, fires again).
export const AE_DELIVERY_GTM_EVENTS = {
  SHOWN: 'aeDeliveryEtaShown',
} as const;
